import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const SelectContentBlockModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "SelectContentBlockModalContainer" */
      './SelectContentBlockModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
